import React, { useState } from 'react';
import { FaTasks, FaFileAlt, FaChevronDown, FaChevronRight, FaEnvelope, FaProjectDiagram, FaUsers } from 'react-icons/fa';
import '../../css/documents/Sidebar.css';

const Sidebar = () => {
  const [dashboardOpen, setDashboardOpen] = useState(false);
  const [documentsOpen, setDocumentsOpen] = useState(true);
  const [mailOpen, setMailOpen] = useState(false);
  const [workflowsOpen, setWorkflowsOpen] = useState(false);
  const [directoryOpen, setDirectoryOpen] = useState(false);

  const handleMenuClick = (type) => {
    console.log('Clicked:', type);
    // Perform navigation or state update
    // For example, navigate(`/documents/${type}`);
  };

  return (
    <div className="sidebar">
      {/* Dashboard */}
      <div className={`menu-item ${dashboardOpen ? 'active' : ''}`} onClick={() => setDashboardOpen(!dashboardOpen)}>
        <div className={`icon-box ${dashboardOpen ? 'active' : ''}`}><FaTasks /></div>
        <span className={`label ${dashboardOpen ? 'bold' : ''}`}>Dashboard</span>
        <span className="arrow">
            {<FaChevronRight />}
        </span>
      </div>
      
      {/* Documents with nested sections */}
      <div className="menu-group">
        <div className={`menu-item ${documentsOpen ? 'active' : ''}`} onClick={() => setDocumentsOpen(!documentsOpen)}>
          <div className={`icon-box ${documentsOpen ? 'active' : ''}`}><FaFileAlt /></div>
          <span className={`label ${documentsOpen ? 'bold' : ''}`}>Documents</span>
          <span className="arrow">
            {documentsOpen ? <FaChevronDown /> : <FaChevronRight />}
          </span>
        </div>

        {documentsOpen && (
          <div className="documents-section">
            {/* Submenu under Documents */}
            <ul className="submenu">
              <li onClick={() => handleMenuClick('register')}>Document Register</li>
              <li onClick={() => handleMenuClick('drawings')}>Drawings</li>
              <li onClick={() => handleMenuClick('temporary-files')}>Temporary Files</li>
            </ul>

            {/* My Organization's Searches */}
            <div className="section">
              <h4>My Organization's Searches</h4>
              <ul className="submenu">
                <li onClick={() => handleMenuClick('BESS')}>IFC Drawings - BESS</li>
                <li onClick={() => handleMenuClick('Solar…')}>IFC Drawings - Solar…</li>
                <li onClick={() => handleMenuClick('Wind…')}>IFC Drawings - Wind…</li>
              </ul>
            </div>

            {/* Standard Searches */}
            <div className="section">
              <h4>Standard Searches</h4>
              <ul className="submenu">
                <li onClick={() => handleMenuClick('approved')}>Approved</li>
                <li onClick={() => handleMenuClick('issued-for-approval')}>Issued for approval</li>
                <li onClick={() => handleMenuClick('drawings-modified-to')}>Drawings modified to…</li>
                <li onClick={() => handleMenuClick('temporary-files-upload')}>Temporary files upload…</li>
              </ul>
            </div>
          </div>
        )}
      </div>

      {/* Mail with nested sections */}
      <div className="menu-group">
        <div className={`menu-item ${mailOpen ? 'active' : ''}`} onClick={() => setMailOpen(!mailOpen)}>
          <div className={`icon-box ${mailOpen ? 'active' : ''}`}><FaEnvelope /></div>
          <span className={`label ${mailOpen ? 'bold' : ''}`}>Mail</span>
          <span className="arrow">
            {mailOpen ? <FaChevronDown /> : <FaChevronRight />}
          </span>
        </div>

        {mailOpen && (
          <div className="documents-section">
            {/* Search */}
            <div className="section">
              <h4>Search</h4>
              <ul className="submenu">
                <li onClick={() => handleMenuClick('all')}>All</li>
                <li onClick={() => handleMenuClick('inbox')}>Inbox</li>
                <li onClick={() => handleMenuClick('sent')}>Sent</li>
                <li onClick={() => handleMenuClick('drafts')}>Drafts</li>
              </ul>
            </div>

            {/* Create New */}
            <div className="section">
              <h4>Create New</h4>
              <ul className="submenu">
                <li onClick={() => handleMenuClick('all')}>Blank Mail</li>
              </ul>
            </div>

            {/* Actions */}
            <div className="section">
              <h4>Actions</h4>
              <ul className="submenu">
                <li onClick={() => handleMenuClick('all')}>Register Incoming Mail</li>
                <li onClick={() => handleMenuClick('all')}>Mail Approvals</li>
              </ul>
            </div>

            {/* My Organization's Searches */}
            <div className="section">
              <h4>My Organization's Searches</h4>
              <ul className="submenu">
                <li onClick={() => handleMenuClick('BESS')}>All letters</li>
              </ul>
            </div>

            {/* Standard Searches */}
            <div className="section">
              <h4>Standard Searches</h4>
              <ul className="submenu">
                <li onClick={() => handleMenuClick('approved')}>My mail received today</li>
                <li onClick={() => handleMenuClick('issued-for-approval')}>My mail sent today</li>
                <li onClick={() => handleMenuClick('drawings-modified-to')}>My Outstanding & Overdue mail</li>
                <li onClick={() => handleMenuClick('temporary-files-upload')}>Org mail not Closed Out</li>
                <li onClick={() => handleMenuClick('temporary-files-upload')}>Org mail received in last 30 days</li>
                <li onClick={() => handleMenuClick('temporary-files-upload')}>Org Outstanding & Overdue mail</li>
                <li onClick={() => handleMenuClick('temporary-files-upload')}>RFIs received reports</li>
              </ul>
            </div>
          </div>
        )}
      </div>

      {/* Workflows with nested sections */}
      <div className="menu-group">
        <div className={`menu-item ${workflowsOpen ? 'active' : ''}`} onClick={() => setWorkflowsOpen(!workflowsOpen)}>
          <div className={`icon-box ${workflowsOpen ? 'active' : ''}`}><FaProjectDiagram /></div>
          <span className={`label ${workflowsOpen ? 'bold' : ''}`}>Workflows</span>
          <span className="arrow">
            {workflowsOpen ? <FaChevronDown /> : <FaChevronRight />}
          </span>
        </div>

        {workflowsOpen && (
          <div className="documents-section">
            {/* Search */}
            <div className="section">
              <h4>Search</h4>
              <ul className="submenu">
                <li onClick={() => handleMenuClick('BESS')}>Workflows</li>
                <li onClick={() => handleMenuClick('Solar…')}>Templates</li>
              </ul>
            </div>

            {/* Standard Searches */}
            <div className="section">
              <h4>Standard Searches</h4>
              <ul className="submenu">
                <li onClick={() => handleMenuClick('approved')}>Assigned to me</li>
                <li onClick={() => handleMenuClick('issued-for-approval')}>Assigned to my organization</li>
                <li onClick={() => handleMenuClick('drawings-modified-to')}>Completed in the last 7 days</li>
                <li onClick={() => handleMenuClick('temporary-files-upload')}>Initiated by me</li>
                <li onClick={() => handleMenuClick('temporary-files-upload')}>Initiated by my organization</li>
                <li onClick={() => handleMenuClick('temporary-files-upload')}>Received in the last 7 days</li>
                <li onClick={() => handleMenuClick('temporary-files-upload')}>Received yesterday</li>
              </ul>
            </div>
          </div>
        )}
      </div>

      {/* Directory */}
      <div className={`menu-item ${directoryOpen ? 'active' : ''}`} onClick={() => setDirectoryOpen(!directoryOpen)}>
        <div className={`icon-box ${directoryOpen ? 'active' : ''}`}><FaUsers /></div>
        <span className={`label ${directoryOpen ? 'bold' : ''}`}>Directory</span>
        <span className="arrow">
            {<FaChevronRight />}
        </span>
      </div>
    </div>
  );
};

export default Sidebar;


